export const USD_DECIMAL = 10;
export const DEFAULT_GAS_LIMIT = 500000;
export const MIN_AMPLIFY = 1.01;
export const MAX_DISCREPANCY = "0.05";
